import React from 'react';
import { fmtDate } from './utils';
import { GRID_TEMPLATE } from './constants';
import type { HistoryEntry } from '../../../../hooks/useCleanupHistory';

interface CleanupHistoryTableProps {
  rows: HistoryEntry[];
  onUndo: (id: string) => void;
}

export default function CleanupHistoryTable({ rows, onUndo }: CleanupHistoryTableProps) {
  return (
    <>
      {rows.map((h) => (
        <div
          key={h.id}
          className="grid gap-4 py-2.5 border-b border-lineSoft items-center text-[12.5px] hover:bg-rowHover"
          style={{ gridTemplateColumns: GRID_TEMPLATE }}
        >
          <div className="text-ink2">{fmtDate(h.dateChanged)}</div>
          <div className="inline-flex items-center gap-2 text-ink font-medium">
            <span className="w-6 h-6 rounded-md bg-panel text-ink2 inline-flex items-center justify-center font-bold text-[11px]">{h.jobIcon}</span>
            {h.jobLabel}
          </div>
          <div className={`inline-flex items-center gap-1.5 ${h.approvedByVela ? 'text-vela-deep' : 'text-ink2'}`}>
            {h.approvedByVela && <span className="w-4 h-4 rounded-full bg-gradient-to-br from-vela to-vela-deep text-white text-[9px] font-extrabold inline-flex items-center justify-center">V</span>}
            {h.approvedBy}
          </div>
          <div className="text-ink2">{h.description}</div>
          <div className="text-right">
            {h.canUndo ? (
              <button
                type="button"
                onClick={() => onUndo(h.id)}
                className="text-[12px] font-semibold cursor-pointer bg-transparent border-none p-0 text-teal-dark hover:underline"
              >
                Undo
              </button>
            ) : (
              <span className="text-[11.5px] text-ink4">Older than 30 days</span>
            )}
          </div>
        </div>
      ))}
    </>
  );
}